import ModelUpdate from "@/models/ModelUpdate";
import Report from "@/models/report/Report";
import {ValidationRule} from "@/declarations/ValidationRule";
import ReportRules from "@/models/report/ReportRules";

export default class ReportUpdate extends ModelUpdate<Report> {

	public userId!: string;
	public orderId!: string;

	public date!: string;
	public fromTime!: string;
	public toTime!: string;
	public breakDuration!: number;

	public licensePlate!: string;
	public notesDriver!: string | null;
	public notesAdministration!: string | null;

	protected initializeWithDetailModelData(detailModel: Report): void {
		this.userId = detailModel.user.id;
		this.orderId = detailModel.order.id;
		this.date = detailModel.date;
		this.fromTime = detailModel.fromTime;
		this.toTime = detailModel.toTime;
		this.breakDuration = detailModel.breakDuration;
		this.licensePlate = detailModel.licensePlate;
		this.notesDriver = detailModel.notesDriver;
		this.notesAdministration = detailModel.notesAdministration;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'userId':
				return ReportRules.userIdRules;
			case 'orderId':
				return ReportRules.orderIdRules;
			case 'date':
				return ReportRules.dateRules;
			case 'fromTime':
				return ReportRules.fromTimeRules;
			case 'toTime':
				return  ReportRules.toTimeRules;
			case 'breakDuration':
				return ReportRules.breakDurationRules(this.fromTime, this.toTime);
			case 'licensePlate':
				return ReportRules.licensePlateRules;
			default:
				return [];
		}
	}

}
